import { authorizedFetch, noAuthorizedFetch, getAccessToken } from './api';

const fetch = () => getAccessToken() ? authorizedFetch : noAuthorizedFetch;

export async function callWidgetApi(api, params, signal = null) {
    return fetch()('/api/widget/finance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ api, params }),
        ...(signal && { signal }),
    });
}

export async function fetchArtifact(artifactId) {
    return fetch()(`/v2/artifacts/${artifactId}`);
}

export async function fetchWidgetArtifact(artifactId, resolveRealtime = true) {
    return fetch()(`/api/widget/artifact/${artifactId}?resolve_realtime=${resolveRealtime}`);
}
